<!-- eslint-disable -->
<template>
</template>
<!-- eslint-enable -->
<script>
export default {
  created() {
    this.$socket.emit('desconectar', this.$store.getters.getSesion)
    var usuariosLogin = localStorage.getItem('usuariosLogin');
    var url = "/login"
    if (process.env.VUE_APP_ISSYS4CONJUNTO == 'true') {
      url += '/' + localStorage.getItem('instalacion')
    }
    localStorage.clear()
    localStorage.setItem('usuariosLogin',usuariosLogin);
    this.$store.reset()
    this.$router.push(url)
  },
};
</script>